var cache = {};
function on(type, func) {
  if (!cache[type]) cache[type] = [];
  var index = cache[type].indexOf(func);
  if (index == -1) cache[type].push(func);
  return function() {
    console.log("移除");
    off(type, func);
  };
}
function off(type, func) {
  let callbacks = cache[type];
  if (callbacks) {
    var index = callbacks.indexOf(func);
    if (index != -1) callbacks.splice(index, 1);
    if (callbacks.length === 0) {
      delete cache[type];
    }
  }
  return callbacks;
}
function offs(type) {
  cache[type] = null;
}
function emitAsync(type, data) {
  if (cache[type]) {
    var cbs = cache[type].concat();
    cbs.forEach(cb => {
      cb(data, type);
    });
  }
}
export default {
  on,
  off,
  offs,
  emitAsync
}